import {app} from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.policies.authentication-access-policies.manage', {
        url: '/:policyId/manage',
        views: {'@company.policies': 'companyPoliciesAuthenticationAccessPoliciesManage'},
        resolve: {
            policy,
            policyId,
        },
    });
}

/** @ngInject */
function policy(policyId, policies) {
    return policies.find(p => p.id === policyId);
}

/** @ngInject */
function policyId($stateParams) {
    return $stateParams.policyId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/policies/authentication-access-policies/manage/manage-policy-apps.state.js